import { render, staticRenderFns } from "./UserReferralIncomes.vue?vue&type=template&id=0df1001a&scoped=true&"
import script from "./UserReferralIncomes.vue?vue&type=script&lang=js&"
export * from "./UserReferralIncomes.vue?vue&type=script&lang=js&"
import style0 from "./UserReferralIncomes.vue?vue&type=style&index=0&id=0df1001a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df1001a",
  null
  
)

export default component.exports